/**
 * Wire-contract header names.
 *
 * These are a server contract, not a local convention: the API rejects a
 * request whose tenant headers are missing or misspelled, and the idempotency
 * key is the one value that has to be identical across the phone's outbox, the
 * HTTP request, and the Contacts table for retry-dedupe to work at all. Spelled
 * as literals they were repeated across the client transport, the transcription
 * upload, and the outbox handler, which is exactly the shape that drifts: a
 * rename lands in some call sites and silently 400s the others.
 */
export const API_HEADERS = {
  /** Selects the tenant database. Required on every request except /api/health. */
  SUBSIDIARY: 'X-Subsidiary',
  /** Selects the campaign scope. Required for campaign-scoped data. */
  CAMPAIGN_ID: 'X-Campaign-Id',
  /**
   * Client-generated UUIDv7 the server folds retries onto. Same value as the
   * outbox entry id and the Contact's ClientRequestId.
   */
  IDEMPOTENCY_KEY: 'Idempotency-Key',
} as const;
